// catalogAliases.js — Shared house and product shorthand/alias maps.
//
// Used by the client-side rule layer (catalogRuleRank.js) and by the Worker's
// photo identification route to normalize house names before catalog search.
// This module has no dependencies and can be imported into both environments.

// Single-token house shorthand ("ysl" → "yves saint laurent"). Typed search
// expands these one token at a time, so every key must be one token.
export const HOUSE_SHORTHAND = Object.freeze({
  ysl: 'yves saint laurent',
  jpg: 'jean paul gaultier',
  pdm: 'parfums de marly',
  mfk: 'maison francis kurkdjian',
  tf: 'tom ford',
  dg: 'dolce and gabbana',
  ch: 'carolina herrera',
  ck: 'calvin klein',
  adp: 'acqua di parma',
  cdg: 'comme des garcons',
  vr: 'viktor and rolf',
  af: 'abercrombie and fitch',
  lv: 'louis vuitton',
  mj: 'marc jacobs',
  xj: 'xerjoff',
  fm: 'frederic malle',
  nr: 'narciso rodriguez',
  vca: 'van cleef and arpels',
  jm: 'jo malone london',
  armani: 'giorgio armani',
  margiela: 'maison margiela',
  replica: 'maison margiela',
  oilperfumery: 'oil perfumery',
})

// Multi-word house names a label prints that the catalog files under a
// shorter house. Kept apart from HOUSE_SHORTHAND because that map is looked up
// one token at a time; these are replaced as whole phrases first, so typed
// search and photo add resolve the same houses.
export const HOUSE_LABEL_ALIASES = Object.freeze({
  'christian dior': 'dior',
  'the dua brand': 'dua',
})

export const PRODUCT_SHORTHAND = Object.freeze({
  bdc: 'bleu de chanel',
  bdcp: 'bleu de chanel parfum',
  swy: 'stronger with you',
  adg: 'acqua di gio',
  adgp: 'acqua di gio profumo',
  dhi: 'dior homme intense',
  cdn: 'club de nuit',
  cdni: 'club de nuit intense',
  cdnim: 'club de nuit intense man',
  br540: 'baccarat rouge 540',
  lme: 'le male elixir',
  lmlp: 'le male le parfum',
  tv: 'tobacco vanille',
  ow: 'oud wood',
  git: 'green irish tweed',
  sms: 'silver mountain water',
  sbe: 'spicebomb extreme',
  ninepm: '9pm',
  mwwh: 'my way',
})
